<template>
    <v-card
            class="ma-3"
            elevation="5"
            min-width="200"
            max-height="500"
            @click="this.dispatchClick"
    >
        <v-row justify="center"
               class="spacing-playground pa-2"
        >
          <v-img
                  :src="getBoarderIcon()"
                  max-width="90"
          >
              <v-row class="fill-height">
                  <v-row justify="center">
                      <v-card-title>
                          <v-img
                                  :src="getItemIcon()"
                                  max-width="60px"
                                  max-height="60px"
                                  dark
                                  class="mt-3"
                          ></v-img>
                      </v-card-title>
                  </v-row>
              </v-row>

          </v-img>
        </v-row>

        <v-row class="pb-1 flex-nowrap text-truncate">
            <v-card-text>
                <v-row justify="center" name="item-card">
                    Level: {{  itemData.level }}
                </v-row>
                <v-row justify="center" name="item-card">
                    Appear GLv.: {{itemData.gameLevel.levelStart}}
                </v-row>
                <v-row justify="center" name="item-card">
                   {{getEndLevel}}
                </v-row>
                <v-row justify="center" name="item-card">
                    {{getBaseType}}: {{getBaseDescription}}
                </v-row>
                <v-row justify="center" name="item-card">
                    Bonus: {{getImpactBonus}}
                </v-row>
                <v-row justify="center" name="item-card">
                    Cost: {{getCost}}
                </v-row>

                <v-row class="mt-5">
                    <v-virtual-scroll
                            item-height="50"
                            height="50"
                            v-if="isJoinImpact()"
                            :items="this.levelCardData.joinLevelDatas"
                    >
                        <template v-slot:default="{ item }">
                            <v-col cols="0" class="mx-0">
                                <v-row justify="center" name="item-card">
                                    {{getJoinBaseType(item)}}: {{getJoinBaseDescription(item)}}
                                </v-row>
                                <v-row justify="center" name="item-card">
                                    Bonus: {{getJoinImpactBonus(item)}}
                                </v-row>
                            </v-col>
                        </template>
                    </v-virtual-scroll>
                </v-row>

            </v-card-text>
        </v-row>
    </v-card>
</template>

<script>
    import ItemColorConstants from "../../../constants/ItemColorConstants.js";
    import GamePlayGroupItem from "@/item-editor/classes/GamePlayGroupItem";
    import {EVENT_TO_UPDATE_SIBLING_ITEM, GlobalEvents} from "@/item-editor/events/GlobalEvents";

    export default {
        name: "SiblingCardItem.vue",
        props: ["pItemData","pLevelCardData"],
        data() {
            return {
                itemData: null,
                levelCardData: null,
            }
        },
        created() {
            this.initItemData();
        },
        watch: {
            pItemData() {
                this.initItemData();
            }
        },
        methods: {
            initItemData(){
                this.itemData = this.pItemData;
                this.levelCardData = this.pLevelCardData;
            },
            getBoarderColor() {
                return ItemColorConstants.colors[this.itemData.color];
            },
            getBoarderIcon() {
                let color = this.itemData.color;
                if (!this.itemData.color) {
                    color = 'blue';
                }
                let iconName = ItemColorConstants.iconColorNames[color];
                return require('../../../assets/icons/itemboarders/' + iconName);
            },
            getItemIcon() {
                let iconName = this.itemData.iconName + ".png";
                let result = null;
                try {
                    result = require('../../../assets/weapons/textures/' + iconName);
                } catch(e){
                    console.log("Not found image name : " + iconName);
                    result = require('../../../assets/weapons/no-image.png');
                }

                return result;
                
            },
            dispatchClick() {
                GlobalEvents.$emit(EVENT_TO_UPDATE_SIBLING_ITEM, this.getItemDataForUpdate());
            },
            getItemDataForUpdate() {
                let itemGroupToEdit = new GamePlayGroupItem({}, this.itemData);
                let itemToEdit = itemGroupToEdit.item;
                itemToEdit.status = "updateSibling";
                return itemToEdit;
            },

            isJoinImpact(){
                return this.levelCardData.joinLevelDatas;
            },
            getJoinImpactBonus(joinLevelData){
                return joinLevelData.bonus;
            },

            getJoinBaseDescription(joinLevelData){
                return joinLevelData.base;
            },

            getJoinRemainingPercentage(joinLevelData){
                return joinLevelData.percentage;
            },

            getJoinBaseType(joinLevelData){
                return joinLevelData.baseType;
            },
            getJoinCost(joinLevelData){
                if (joinLevelData.costInGold){
                    return joinLevelData.costInGold.ToReadableAlphabetV2() + " coins";
                }
                else {
                    return "unknown"
                }
            },

        },
        computed: {
            getItemTitleName() {
                let title = this.itemData.title;
                if (title !== undefined) {
                    return title.en;
                }
                return "N/A";
            },

            getImpactBonus(){
                return this.levelCardData.bonus;//.toFixed(2);
            },

            getBaseDescription(){
                return this.levelCardData.base;
            },

            getRemainingPercentage(){
                return this.levelCardData.percentage;
            },

            getBaseType(){
                return this.levelCardData.baseType;
            },
            getCost(){
                if (this.levelCardData.costInGold){
                    return this.levelCardData.costInGold.ToReadableAlphabetV2() + " coins";
                }
                else {
                    return "unknown"
                }
            },
            getEndLevel(){
                // Finish GLv.: {{itemData.gameLevel.levelEnd - 1}}
                let levelEnd = this.itemData.gameLevel.levelEnd - 1;
                if(levelEnd < 0){
                    return "No ending GLv";
                }
                return "Finish GLv.:"+ levelEnd;//for end last level
            }
        },
    }
</script>

<style scoped>
    .v-list--two-line .v-list-item,
    .v-list-item--two-line {
        min-height: 30px;
        height:30px;
    }
</style>